export const languages = [
  {
    name: 'Spanish',
    flag: 'spanish.png'
  },
  {
    name: 'English',
    flag: 'english.png'
  },
  {
    name: 'French',
    flag: 'french.png'
  },
  {
    name: 'German',
    flag: 'german.png'
  },
  {
    name: 'Mandarin',
    flag: 'mandarin.png'
  },
  {
    name: 'Italian',
    flag: 'italian.png'
  },
  {
    name: 'Russian',
    flag: 'russian.png'
  },
  {
    name: 'Portuguese',
    flag: 'portuguese.png'
  },
  {
    name: 'Arabic',
    flag: 'arabic.png'
  },
  {
    name: 'Japanese',
    flag: 'japan.png'
  }
];

export var flags = {};
for (const language of languages) {
  flags[language.name] = language.flag
}



// WEBPACK FOOTER //
// ./src/config/languages.js